module.exports = __webpack_public_path__ + "static/media/599.705493(3).2054d94a.pdf";